import { inject, Injectable } from '@angular/core';

import { DialogRef, DialogService } from '@hglobal/common';

import {
  ViewRequestDetailsDialogData,
  ViewRequestDetailsComponent,
} from './view-request-details.component';

@Injectable()
export class ViewRequestDetailsDialog {
  readonly #dialogService = inject(DialogService);

  open(
    { requestId, injector, requestDetails, mode }: ViewRequestDetailsDialogData,
  ): DialogRef {
    return this.#dialogService.open(
      ViewRequestDetailsComponent,
      { requestId, requestDetails, mode },
      { parentInjector: injector },
    );
  }
}
